import { Component } from "@angular/core";
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({ standalone: false,
  selector: "irb-dropdown-cell",
  template: `
    <div [ngClass]="{ 'cell-dropdown': isEditable, 'cell-dropdown-disabled': !isEditable }">
      <div class="input-field">
        <div class="input-field-text">{{ value?.name }}&nbsp;</div>
        @if (isEditable) {
          <i class="pi pi-chevron-down"></i>
        }
      </div>
    </div>
    `,
})
export class DropdownRendererComponent implements ICellRendererAngularComp {
  params: any;
  value: any;
  isEditable: boolean = true;
  isDisabled: boolean = false;
  isNotApplicable: boolean = false;

  constructor() {}

  agInit(params: any) {
    this.params = params;
    this.value = this.params.defaultValue;
    this.isEditable = params.disableValueField ? !params.data[params.disableValueField] : true;
    this.isDisabled = this.params.isDisabled || false;
    this.isNotApplicable = this.params.isNotApplicable || false;

    if (this.isDisabled) {
      this.isEditable = false;
    }

    if (this.isNotApplicable) {
      this.value = {
        name: "n/a",
      };
    } else {
      for (let i = 0; i < this.params.values.length; i++) {
        if (this.params.values[i][this.params.identifier] === this.params.value) {
          this.value = this.params.values[i];
          break;
        }
      }
    }
  }

  refresh(): boolean {
    return true;
  }
}
